import { useGrowthbook } from '@experience/core-hostapp-share-lib';

// INFO: 18 позиций для 4:3 эксперимента
const EXP_PAID_POSITIONS = '0,1,2,3,7,8,9,10,14,15,16,17,21,22,23,24,28,29';

export const usePaidPositionsDensityExperiment = () => {
  const gb = useGrowthbook();

  const isPaidPositionsDensityActive = gb?.isOn('paid_positions_density') ?? false;

  return {
    isPaidPositionsDensityActive,
    paidPositionsValue: EXP_PAID_POSITIONS,
  };
};
